<template>
  <div class="dialog-more flex-al-stretch flex-align-center flex-jc-bt" style="max-height: 80vh;">
    <div class="flex-50" style="border-right: 1px dashed #3A909D">
      <p v-triangle class="fs-bold">{{ $l('CompanyInformation') }}</p>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanySerialNo') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.serialNo }}</div>
      </div>
      <div v-if="id && allInfo?.id" class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Staff') }}</div>
        <div class="flex-47">{{ staffCount }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyNameEnglish') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.name }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyNameNativeLanguage') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.nativeName }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('PositioninOrganizationChart') }}</div>
        <div class="flex-47">{{ $l(companyPosition[subNodeDefaultCorp.level]?.title) }}</div>
      </div>

      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('RegisterCountrySAR') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.regCountry?.name }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('AreaCodeofCountryorSAR') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.regCountryCode }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('City') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.regCity?.name }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('AreaCodeofCity') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.regCityCode }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('AboutCompanyName') }}</div>
        <div class="flex-47">
          <div>{{ $l(aboutCompanyName[subNodeDefaultCorp.regLevel]?.title) }}</div>
          <!--          <div class="sp-color-7">{{ $l(aboutCompanyName[subNodeDefaultCorp.regLevel]?.tip) }}</div> -->
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('ShiplusAccessIdentity') }}</div>
        <div class="flex-47">
          <div class="mg-b-10">
            <div>{{ $L(companyCategory[subNodeDefaultCorp.identity]?.title) }}</div>
            <div class="sp-color-7">{{ $L(companyCategory[subNodeDefaultCorp.identity]?.tip) }}</div>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyCategory') }}</div>
        <div class="flex-47">
          <div v-if="subNodeDefaultCorp.privSign === 1">
            <div>{{ $L('SigningRightCompany') }}</div>
            <div class="sp-color-7">{{ $L('SigningRightCompanyTip') }}</div>
          </div>
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('RegistrationNo') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.registrationNo }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('RegisteredOfficeAddress') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.regAddress }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('IncorporationDate') }}</div>
        <div class="flex-47">{{ getDateToFormatEn(subNodeDefaultCorp.incorporationDate, false) }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Incorporator') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.incorporator }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Assets') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.otherAssets }}</div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Website') }}</div>
        <div class="flex-47">{{ subNodeDefaultCorp.website }}</div>
      </div>
      <!--      <div class="flex-jc-bt pop-item"> -->
      <!--        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Others') }}</div> -->
      <!--        <div class="flex-47 ">{{ subNodeDefaultCorp.otherRemark }}</div> -->
      <!--      </div> -->

      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CompanyProfile') }}</div>
        <div class="flex-47">
          <SpSection :content="subNodeDefaultCorp.introduction" />
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('FixtureList') }}</div>
        <div class="flex-47">
          <SpSection :content="subNodeDefaultCorp.tradeRemark" />
        </div>
      </div>
      <p v-triangle class="fs-bold">{{ $l('SomeSupportingFilesPicturesPDForOthers') }}</p>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('CertificateofRegister') }}</div>
        <div class="flex-47">
          <el-image
            v-for="img in corpCertificateFileList"
            style="width: 28px; height: 40px;margin-right: 20px"
            :src="img.url"
            :preview-src-list="corpCertificateFileList.map(file => file.url)" />
          <!--          <SpUploadGroup ref="corpLogo" -->
          <!--                         :disabled="true" -->
          <!--                         :default-files="corpCertificateFileList" /> -->
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Others') }}</div>
        <div class="flex-47">
          <el-image
            v-for="img in registrationOtherFileList"
            style="width: 28px; height: 40px; margin-right: 20px"
            :src="img.url"
            :preview-src-list="registrationOtherFileList.map(file => file.url)" />
          <!--          <SpUploadGroup ref="corpLogo" -->
          <!--                         :disabled="true" -->
          <!--                         :default-files="registrationOtherFileList" /> -->
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Method1') }}</div>
        <div class="flex-47">
          <SpUpload
            style="margin-left: -20px"
            :disabled="true"
            :default-files="fixtureListFiles"
            file-type="corp/trade/file"
            type="primary" />
        </div>
      </div>
      <div class="flex-jc-bt pop-item">
        <div v-title class="flex-50 pop-item-title sp-color-7">{{ $l('Method2') }}</div>
        <div class="flex-47">
          <el-image
            v-for="img in tradeRecordPics"
            style="width: 28px; height: 40px;margin-right: 20px"
            :src="img.url"
            :preview-src-list="tradeRecordPics.map(file => file.url)" />
          <!--          <SpUploadGroup ref="corpLogo" -->
          <!--                         :disabled="true" -->
          <!--                         :default-files="registrationOtherFileList" /> -->
        </div>
      </div>
    </div>
    <!-- 竖轴分割线 -->
    <sp-divider :height="1" />
    <div class="flex-50">
      <!-- BasicInformation -->
      <div>
        <div v-triangle class="fw-bold mg-t-10 pd-l-40">
          {{ $l('DepartmentInformation') }}
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('DeptOrFuncTeam(en)') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.name }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title" style="font-size: 15.5px">
            {{ $l('DeptOrFuncTeam(native)') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.nativeName }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('CodeName(en)') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.codeName }}
          </div>
        </div>
        <div class="flex-al-center flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('Picture') }}
          </div>
          <div class="flex-42 text">
            <el-image
              v-for="img in deptLogo"
              style="width: 28px; height: 40px;margin-right: 20px"
              :src="img.url"
              :preview-src-list="deptLogo.map(file => file.url)" />
            <!--            <SpUploadGroup ref="corpLogo" -->
            <!--                           :disabled="true" -->
            <!--                           :default-files="deptLogo" /> -->
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('CountryOrSAR') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.country?.name }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('AreaCodeSAR') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.countryCode }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('City') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.city?.name }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('AreaCodeOfCity') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.cityCode }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('EmailAddress') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.emails }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('Skype') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.skype }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('TElREP') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.telRep }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('TELDIR') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.telDir }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('Fax') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.fax }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('OtherContacts') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.others }}
          </div>
        </div>

        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('DepartmentSerialNo') }}
          </div>
          <div class="flex-42 text">
            {{ deptInfo.serialNo }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('CompanySerialNo') }}
          </div>
          <div class="flex-42 text">
            {{ subNodeDefaultCorp.serialNo }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('CompanyDeptJoint') }}
          </div>
          <div class="flex-42 text">
            {{ masterNodeDefaultCorp?.serialNo ? masterNodeDefaultCorp.serialNo + '-' + subNodeDefaultCorp.serialNo + '-' + deptInfo.serialNo : subNodeDefaultCorp.serialNo + '-' + deptInfo.serialNo }}
          </div>
        </div>
      </div>
      <!--      job -->
      <div>
        <div v-triangle class="fw-bold mg-t-10 pd-l-40">
          {{ $l('Job Title & Description') }}
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('DeptAccessIdentity') }}
          </div>
          <div class="flex-42 text">
            <div>{{ $L(companyCategory[job.identity]?.title) }}</div>
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title" style="font-size: 15.5px">
            {{ $l('Responsibility') }}
          </div>
          <div class="flex-42 text">
            {{ job.profession?.name }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('Position') }}
          </div>
          <div class="flex-42 text">
            {{ job.position?.name }}
          </div>
        </div>
        <div class="flex-jc-bt item mg-t-20">
          <div class="flex-55 flex-jc-end sp-color-7 title">
            {{ $l('JobDescription') }}
          </div>
          <div class="flex-42 text">
            <SpSection :content="job.description" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateToFormatEn, formatLogo, formatFiles } from '@/utils/convert'
import {
  ABOUT_COMPANY_NAME,
  COMPANY_CATEGORY,
  COMPANY_POSITION,
  DEPT_IDENTITY,
  DEPT_FUN, ACCESS_IDENTITY
} from '@/config/company'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpUpload from '@/components/common/SpUpload'
import SpSection from '@/components/common/SpSection'
import { getOfferDetailAPI } from '@/request/APIs/natural'

export default {
  name: 'DepartMentDetail',
  components: { SpUploadGroup, SpUpload, SpSection },
  nameSpace: 'company.DepartmentDynamics',
  props: {
    id: {
      type: Number,
      default: null
    },

    info: {
      type: Object,
      default: {}
    }
  },

  data () {
    return {
      allInfo: {},
      deptInfo: {},
      subNodeDefaultCorp: {},
      // staffCount: 0,
      masterNodeDefaultCorp: {},

      companyCategory: ACCESS_IDENTITY,
      companyPosition: COMPANY_POSITION,
      aboutCompanyName: ABOUT_COMPANY_NAME,
      deptIdentity: DEPT_IDENTITY,
      deptFun: DEPT_FUN,
      getDateToFormatEn,
      job: {}
    }
  },

  computed: {
    deptLogo () {
      return formatLogo(this.deptInfo, 'photo')
    },

    staffCount () {
      return this.allInfo?.dept?.subNode?.staffCount || 0
    },

    companyLogo () {
      return formatLogo(this.subNodeDefaultCorp, 'logo')
    },

    corpCertificateFileList () {
      return formatFiles(this.subNodeDefaultCorp, 'certificate')
    },

    registrationOtherFileList () {
      return formatFiles(this.subNodeDefaultCorp, 'otherRegistrationFiles')
    },

    fixtureListFiles () {
      const list = []
      if (this.subNodeDefaultCorp.tradeRecordFiles?.files) {
        const files = this.subNodeDefaultCorp.tradeRecordFiles.files
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key,
            name: key
          })
        })
      }
      return list
    },

    tradeRecordPics () {
      return formatFiles(this.subNodeDefaultCorp, 'tradeRecordPics')
    }
  },

  watch: {
    id (n) {
      if (n) {
        if (!this.info?.id) {
          this.getDetail(n)
        } else {
          this.deptInfo = this.info.department
          this.job = this.info.job

          this.subNodeDefaultCorp = this.deptInfo?.companies?.sub
          this.masterNodeDefaultCorp = this.deptInfo?.companies?.master
        }
      }
    }
  },

  methods: {
    getDetail (id) {
      getOfferDetailAPI(id).then(res => {
        console.log(res)
        this.allInfo = res.data
        this.deptInfo = res.data.dept
        this.job = res.data.job

        this.subNodeDefaultCorp = this.deptInfo?.subNode?.defaultCorp ? this.deptInfo?.subNode?.defaultCorp : this.deptInfo?.masterNode?.defaultCorp

        this.masterNodeDefaultCorp = this.deptInfo?.masterNode?.defaultCorp
      })
    },

    formatFiles (info, key) {
      const list = []
      if (info[key]?.files) {
        const files = info[key].files
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key
          })
        })
      }
      return list
    }
  }
}
</script>

<style scoped lang="less">
.item{
  font-family: Arial;
}
.pop-item{
  font-family: Arial;
  padding: 10px 0;
  .pop-item-title{
    text-align: right;
  }
}
</style>
